
import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import io from 'socket.io-client';
import { useAuth } from './AuthContext';
import useToast from '../hooks/useToast';

const SocketContext = createContext(null);

export const useSocket = () => useContext(SocketContext);

// const SOCKET_URL =
// process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';


const SOCKET_URL ='https://nfcfied-access-backend.onrender.com';



export const SocketProvider = ({ children }) => {
  const { user, logout } = useAuth();
  const { showToast } = useToast();
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem('token');

    if (!user?._id || !token) {
      setSocket(null);
      return undefined;
    }

    const newSocket = io(SOCKET_URL, {
      auth: { token },
      reconnection: true,
    });

    let deactivationHandled = false;

    const handleConnectError = (error) => {
      console.error('Socket connection error:', error.message);
    };

    const handleAccountDeactivated = (data) => {
      // Handle deactivation only once.
      if (
        deactivationHandled ||
        !sessionStorage.getItem('token')
      ) {
        return;
      }

      deactivationHandled = true;

      // Display the notification before clearing authentication.
      showToast(
        'error',
        data?.message ||
          'Your account has been deactivated. You have been logged out.',
        3000
      );

      // Clear the session and update React state.
      // App.jsx/App.js will automatically display the login route.
      logout();
    };

    newSocket.on('connect_error', handleConnectError);
    newSocket.on(
      'accountDeactivated',
      handleAccountDeactivated
    );

    setSocket(newSocket);

    return () => {
      newSocket.off('connect_error', handleConnectError);
      newSocket.off(
        'accountDeactivated',
        handleAccountDeactivated
      );

      newSocket.disconnect();

      setSocket((currentSocket) =>
        currentSocket === newSocket ? null : currentSocket
      );
    };
  }, [user?._id, logout, showToast]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;
